import posthog from 'posthog-js';
import { getSABAppInstance_Normal } from './shopify-app-bridge/app';
import { getSessionToken } from '@shopify/app-bridge/utilities';

const initPosthog = async tenantApp => {
  const app = getSABAppInstance_Normal();
  const token = await getSessionToken(app);
  console.log('====== token: ', token);
  const email = tenantApp?.externalInfo?.email || tenantApp?.optEmail || '';
  posthog.identify(email, {
    email
  });
};

export { initPosthog };
